import { GetterTree } from "vuex";
import { CLIENTES } from "./types";
import { RootState } from "@/store/modules/general/types";

type AuthGetterTree = GetterTree<CLIENTES, RootState>;

export const getters: AuthGetterTree = {
  
};
